import { AnimateBox } from '../../components/animate-box'
import { Pack } from '../../components/pack'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'

import type { SolutionTag } from '../../pageContents'

const bannerUrl = `${STATIC_OBS_URL}/website/home/solution/banner2.jpg?2`

export interface SolutionListProps {
  tagInfo: SolutionTag
  tagList: SolutionTag[]
}

export const SolutionList = (props: SolutionListProps) => {
  const { tagInfo, tagList } = props
  return (
    <Wrap className='solution-list'>
      <div className='wrap'>
        <div className='public-banner-box'>
          <div className='mask' style={{ backgroundImage: `url(${bannerUrl})` }} />
          <AnimateBox tagName='h2'>{tagInfo.title}</AnimateBox>
          {/* <AnimateBox animateDelay={0.5} tagName='p'>
            集成数字孪生、控制系统开发、HIL 仿真等全栈解决方案，为工业智能化转型提供强大技术支持
          </AnimateBox> */}
        </div>

        <div className='public-tab-box white'>
          <div className='inner-wrap'>
            {tagList.map((item, i) => {
              const { id, name } = item
              const className = name === tagInfo.name ? 'cur' : ''
              const href = `/solution/${id}`
              return (
                <AnimateBox animateDelay={1 + 0.3 * i} key={href}>
                  <a className={className} href={href}>
                    {name}
                  </a>
                </AnimateBox>
              )
            })}
          </div>
        </div>

        <div className='title-box'>
          <AnimateBox animateDelay={2} tagName='h2'>
            {tagInfo.title}
          </AnimateBox>
          <AnimateBox animateDelay={2.5} tagName='p'>
            {tagInfo.descriptions}
          </AnimateBox>
        </div>

        <div className='content-box'>
          {tagInfo.topic ? (
            <div className='topic'>
              <img alt='' src={tagInfo.topic} />
            </div>
          ) : null}
          <ul className='card-1'>
            {tagInfo.list.map(item => {
              const { title, discriptions = '', thumbnail, thumbnails } = item
              return (
                <li key={title}>
                  <div className='box'>
                    <AnimateBox className='txt'>
                      <h2>{title}</h2>
                      <div
                        className='discriptions'
                        dangerouslySetInnerHTML={{ __html: discriptions }}
                      />
                    </AnimateBox>
                    <AnimateBox animateDelay={0.5} className='img'>
                      <img alt={title} className='pic' src={thumbnail} />
                    </AnimateBox>
                  </div>
                  <Pack className='thumbnails' if={thumbnails.length > 0}>
                    {thumbnails.map(item => {
                      return <img alt={item} key={item} src={item} />
                    })}
                  </Pack>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </Wrap>
  )
}
